import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
import usePermissions from '@/hooks/use-permissions';
import useSession from '@/hooks/use-session';
import { isAgentsTabAccessible } from '@/utils/agents-access';
import MenuDropdown, { type MenuLink } from '../menu-dropdown';
export type SettingsDropdownProps = {
  href: string;
  text: string;
  icon: Icon;
  isCollapsed: boolean;
  pathname: string;
};
const SettingsDropdown = t0 => {
  const $ = _c(39);
  const {
    href,
    text,
    icon: Icon,
    isCollapsed,
    pathname
  } = t0;
  const {
    t
  } = useTranslation("settings");
  const {
    data: t1
  } = useSession();
  const {
    user,
    org
  } = t1;
  const {
    isAdmin,
    isAuditor
  } = usePermissions();
  const shouldShowBilling = org?.id === "org_AiK8peOw9mrqsb6yeHWEG8" && isAdmin || user?.isFirmEmployee;
  const t2 = `${href}/business-profile`;
  let t3;
  if ($[0] !== t) {
    t3 = t(_temp);
    $[0] = t;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = {
      href: t2,
      text: t3
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `${href}/team-roles`;
  let t6;
  if ($[5] !== t) {
    t6 = t(_temp2);
    $[5] = t;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = {
      href: t5,
      text: t6
    };
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = `${href}/statuses`;
  let t9;
  if ($[10] !== t) {
    t9 = t(_temp3);
    $[10] = t;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t8 || $[13] !== t9) {
    t10 = {
      href: t8,
      text: t9
    };
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let links;
  if ($[15] !== href || $[16] !== shouldShowBilling || $[17] !== t || $[18] !== t10 || $[19] !== t4 || $[20] !== t7 || $[21] !== user) {
    links = [t4, t7, t10];
    if (isAgentsTabAccessible({
      user
    })) {
      const t11 = `${href}/browser`;
      let t12;
      if ($[23] !== t) {
        t12 = t(_temp4);
        $[23] = t;
        $[24] = t12;
      } else {
        t12 = $[24];
      }
      let t13;
      if ($[25] !== t11 || $[26] !== t12) {
        t13 = {
          href: t11,
          text: t12
        };
        $[25] = t11;
        $[26] = t12;
        $[27] = t13;
      } else {
        t13 = $[27];
      }
      links.push(t13);
    }
    if (shouldShowBilling) {
      const t11 = `${href}/billing`;
      let t12;
      if ($[28] !== t) {
        t12 = t(_temp5);
        $[28] = t;
        $[29] = t12;
      } else {
        t12 = $[29];
      }
      let t13;
      if ($[30] !== t11 || $[31] !== t12) {
        t13 = {
          href: t11,
          text: t12
        };
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
      } else {
        t13 = $[32];
      }
      links.push(t13);
    }
    $[15] = href;
    $[16] = shouldShowBilling;
    $[17] = t;
    $[18] = t10;
    $[19] = t4;
    $[20] = t7;
    $[21] = user;
    $[22] = links;
  } else {
    links = $[22];
  }
  const subLinks = links;
  if (isAuditor) {
    return null;
  }
  let t11;
  if ($[33] !== Icon || $[34] !== isCollapsed || $[35] !== pathname || $[36] !== subLinks || $[37] !== text) {
    t11 = <MenuDropdown text={text} icon={Icon} isCollapsed={isCollapsed} subLinks={subLinks} pathname={pathname} />;
    $[33] = Icon;
    $[34] = isCollapsed;
    $[35] = pathname;
    $[36] = subLinks;
    $[37] = text;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  return t11;
};
export default SettingsDropdown;
function _temp($) {
  return $.pages.businessProfile.title;
}
function _temp2($_0) {
  return $_0.pages.teamRoles.title;
}
function _temp3($_1) {
  return $_1.pages.statuses.title;
}
function _temp4($_2) {
  return $_2.pages.browser.title;
}
function _temp5($_3) {
  return $_3.pages.billing.title;
}